import '@/installCompositionApi'
import '@/installFineMq'

import { mount } from '@/mounter'

import SanitasMagazineTeasers from '../common/MagazineTeasers'

mount('magazine-teaser', SanitasMagazineTeasers)
